"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootSaga = rootSaga;
var _effects = require("redux-saga/effects");
var _rootSaga = _interopRequireDefault(require("../../astercore/common/redux/rootSaga"));
var _rootSaga2 = _interopRequireDefault(require("../../teleconsultant/common/redux/rootSaga"));
var _rootSaga3 = _interopRequireDefault(require("../../epharmacy/common/redux/rootSaga"));
var _rootSaga4 = _interopRequireDefault(require("../../DOD/common/redux/rootSaga"));
var _rootSaga5 = _interopRequireDefault(require("../../homecare/common/redux/rootSaga"));
// Imports: Dependencies

// Imports: Redux Sagas

// Redux Saga: Root Saga
function* rootSaga() {
  yield (0, _effects.all)([..._rootSaga.default, ..._rootSaga2.default, ..._rootSaga3.default, ..._rootSaga4.default, ..._rootSaga5.default]);
}